import { routeAdacter } from 'adapters';
import { contextApp } from 'context';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { routeService } from 'services';
import useErrors from './useErrors';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const useRoutes = () => {
 const { auth, allow } = contextApp();
 const { setError } = useErrors();
 const [show, setShow] = useState(false);
 const [routes, setRoutes] = useState([]);
 const [data, setData] = useState([]);
 const [permits, setPermits] = useState([]);
 const [parentsIds, setParentsIds] = useState([]);
 const [categories, setCategories] = useState([]);
 const [inputValue, setInputValue] = useState('');
 const [selectValue, setSelectValue] = useState(0);
 const [newPermits, setNewPermits] = useState([]);
 const [assignment, setAssignment] = useState({});
 const [isLoading, setIsLoading] = useState(false);

 const [filterOptions, setFilterOptions] = useState([]);
 const [selectedItems, setSelectedItems] = useState([]);
 const [disabled, setDisabled] = useState(!allow.includes('bpcsCj7_e94asJKjuC66'));

 const { getCategories, createRoute, updateRoute } = routeService.useApiRoutes();
 const queryClient = useQueryClient();
 const { mutate: createCategory } = useMutation(createRoute);
 const { mutate: updateCategory } = useMutation(updateRoute);

 useQuery({
  queryKey: ['routesCategory'],
  queryFn: () => getCategories(),
  onSuccess: data => {
   const [standardRoutes, ktgories] = routeAdacter.categories(data, categories);
   setData(standardRoutes);
   if (ktgories) setCategories(ktgories);
  },
  onError: err => setError(err)
 });

 const getItems = (routes, ids) => {
  let parentsIds = [];
  const permissions = [];

  const search = routes => {
   let item = [];
   let newRoute = [];
   for (let e of routes) {
    const { id, name, allow, permits, children } = e;
    if (ids.includes(id)) {
     item.push(id);
     newRoute.push({ ...e, active: true });
     if (permits && !permissions.some(a => a.id === id)) permissions.push({ id, name, allow, permits });
    }
    if (children) {
     const [d, childrn] = search(children);
     if (d.length) {
      item.push(...d, id);
      parentsIds = [...parentsIds, id];
      newRoute.push({ ...e, active: true, children: childrn });
      if (permits && !permissions.some(a => a.id === id)) permissions.push({ id, name, allow, permits });
     }
    }
   }
   return [item, newRoute];
  };

  const [, newRoutes] = search(routes);
  const mySet2 = new Set(parentsIds);
  setRoutes(newRoutes);
  setPermits(permissions);
  setParentsIds([...mySet2]);
 };

 const manageCategory = (assign = false) => {
  setIsLoading(true);
  const treatRoutes = routes => {
   let newRoute = [];
   for (let route of routes) {
    const { id, children } = route;
    const isAllowed = newPermits.find(p => p.id === id);
    if (isAllowed) route = { ...route, ...isAllowed };

    if (children) newRoute.push({ ...route, children: treatRoutes(children) });
    else newRoute.push(route);
   }
   return newRoute;
  };

  const root = treatRoutes(routes);
  if (!root.length || !inputValue) return toast.info(`Existen campos vacios`);

  setAssignment({ category: inputValue, routes: root, creator: auth.fullName });

  if (assign) return setShow(false);

  if (selectValue == 0)
   createCategory(
    { category: inputValue, routes: root, creator: auth.fullName },
    {
     onSuccess: () => {
      queryClient.invalidateQueries(['routesCategory']);
      setShow(false);
     },
     onSettled: () => setIsLoading(false),
     onError: err => setError(err)
    }
   );
  else
   updateCategory(
    { category: inputValue, routes: root, creator: auth.fullName, id: selectValue },
    {
     onSuccess: () => {
      queryClient.invalidateQueries(['routesCategory']);
      setShow(false);
     },
     onSettled: () => setIsLoading(false),
     onError: err => setError(err)
    }
   );
 };

 const setCategoryChange = () => {
  if (selectValue == 0 || !selectValue) {
   setSelectedItems([]);
   setInputValue('');
   setNewPermits([]);
   setFilterOptions([]);
   setDisabled(!allow.includes('bpcsCj7_e94asJKjuC66'));
   return;
  }

  const objRoutes = {
   ...categories.find(e => e._id == selectValue),
   ...(assignment?.category === selectValue ? assignment : {})
  };

  const routesFormat = paths => {
   const arrayItems = [];
   const permissions = [];
   const options = [];
   const routesPermits = routes => {
    routes.map(route => {
     const { id, name, allow, permits, children } = route;
     if (allow && allow.length) {
      permissions.push({ id, name, allow, permits });
      options.push(...allow);
     }
     if (!children && id) arrayItems.push(id);
     if (children) {
      routesPermits(children);
     }
    });
   };
   paths && routesPermits(paths);
   return [arrayItems, permissions, options];
  };

  setDisabled(!allow.includes('bpcsCj7_e94asJKjuC55'));
  setInputValue(objRoutes?.category ?? '');
  const [arrayItems, permissions, options] = routesFormat(objRoutes?.routes);
  setSelectedItems(arrayItems);
  setNewPermits(permissions);
  setFilterOptions(options);
 };

 useEffect(() => {
  setDisabled(!allow.includes('bpcsCj7_e94asJKjuC66'));
 }, [allow]);

 useEffect(() => {
  getItems(data, selectedItems);
 }, [selectedItems]);

 useEffect(() => {
  setCategoryChange();
 }, [selectValue, categories]);

 const handleFilterOptions = ({ target }, obj) => {
  const { type, value, checked } = target;
  if (type === 'checkbox') {
   let options = [...filterOptions];
   options = options.filter(option => option !== value);

   checked && options.push(value);
   const newPermissions = newPermits.filter(e => e.id !== obj.id);
   setNewPermits([...newPermissions, { ...obj, allow: options }]);
   setFilterOptions(options);
  }
 };

 return {
  data,
  routes,
  permits,
  handleFilterOptions,
  filterOptions,
  selectedItems,
  parentsIds,
  setParentsIds,
  setFilterOptions,
  setSelectedItems,
  categories,
  setInputValue,
  disabled,
  inputValue,
  selectValue,
  setSelectValue,
  manageCategory,
  setAssignment,
  assignment,
  show,
  setShow,
  isLoading
 };
};

export default useRoutes;
